$(document).on("turbolinks:load", function () {
  //*******************************************
  //*. 関数の定義                           *
  //*******************************************
  // ● ローディング管理（pt入力欄）
  let currentPtCalcRequest = null; // 得点→pt 計算の進行中XHR
  let currentPtCalcRequestToken = 0; // 進行中XHRの識別トークン（最新のみがUIを更新）
  let currentLeagueRuleListRequestToken = 0; // リーグのルール一覧更新XHR（最新のみ反映）

  function startPtLoading() {
    $('[id$="_point"]').each(function () {
      $(this)
        .closest("#match-form-pt")
        .addClass("is-loading")
        .attr("aria-busy", "true");
      $(this).prop("disabled", true);
    });
  }

  function stopPtLoading() {
    $('[id$="_point"]').each(function () {
      $(this)
        .closest("#match-form-pt")
        .removeClass("is-loading")
        .removeAttr("aria-busy");
      $(this).prop("disabled", false);
    });
  }
  // ● 残得点の更新
  function updateRemainingScore() {
    let scores = [];
    $('[id$="_score"]').each(function () {
      scores.push($(this).val());
    });

    let total_score = scores
      .filter((v) => v)
      .reduce(function (sum, element) {
        return sum + parseInt(element, 10);
      }, 0);

    let remainingScoreText = $(".js-remaining_score_hidden_value")
      .text()
      .trim();
    let remainingScore = parseInt(remainingScoreText, 10);
    let calculatedRemainingScore = remainingScore - total_score * 100;
    $(".js-remaining_score_value").text(calculatedRemainingScore);

    // 残得点に応じてアイコンと色を切り替え
    if (calculatedRemainingScore === 0) {
      $(".js-remaining_score_icon")
        .removeClass("fa-xmark text-red")
        .addClass("fa-check text-green");
      $(".js-remaining_score_value").css("color", "");
    } else {
      $(".js-remaining_score_icon")
        .removeClass("fa-check text-green")
        .addClass("fa-xmark text-red");
      $(".js-remaining_score_value").css("color", "red");
    }

    // 残得点が0でなくても保存はできるため、注意だけ出す
    window.Janreco.toggleFormWarning("#match_create_warning", "remaining-not-zero",
                                     calculatedRemainingScore !== 0, "caution");
  }

  // ● ルール選択肢で選択された時のjs
  function clearRuleUI() {
    $(".js-rule-details").hide();
    $(".js-rule-dropdown i").removeClass("fa-caret-down").addClass("fa-caret-right");
    var labelOpen = $(".js-rule-dropdown").data("label-open");
    $(".js-rule-dropdown span.ps-1").text(labelOpen);
    $(".js-rule-badge-mochi-kaeshi, .js-rule-badge-uma, .js-rule-badge-pt-calc, .js-rule-badge-chip, .js-rule-badge-tie").text("");
    $(".js-remaining_score span").remove();

    // league作成・編集ページのとき
    if (
      /^\/leagues\/[^/]+\/edit$/.test(window.Janreco.currentPath()) ||
      /^\/leagues\/new$/.test(window.Janreco.currentPath())
    ) {
      // ルール未選択/取得失敗時は「リーグ成績にチップptを含めるか」を必ず非表示に戻す
      updateIsTipValid(false);
    }
  }

  function selectRule(selector) {
    let id = $(selector).val();
    // idが空の場合はリクエストを送信しない
    if (!id) {
      clearRuleUI();
      return;
    }
    $.ajax({
      type: "GET", // リクエストのタイプ
      url: "/rules/searches", // リクエストを送信するURL
      data: { id: id }, // サーバーに送信するデータ
      dataType: "json", // サーバーから返却される型
    })
      // 正常にデータを受け取れた際の処理
      .done(function (data) {
        $(".js-remaining_score span").remove();
        let all_score = data.mochi * data.play_type;
        let value = data.score_decimal_point_calc;
        let pt_calc = "";

        // league作成・編集ページのとき
        if (
          /^\/leagues\/[^/]+\/edit$/.test(window.Janreco.currentPath()) ||
          /^\/leagues\/new$/.test(window.Janreco.currentPath())
        ) {
          updateIsTipValid(data.is_chip); //「リーグ成績にチップptを含めるか」項目を表示・非表示にする
        }

        var $wrapper = $(".js-rule-badges-wrapper");
        var ptCalcLabels = $wrapper.data("pt-calc-labels");
        pt_calc = ptCalcLabels[value] || "";

        var tieSplit = $wrapper.data("tie-split");
        var tieKamicha = $wrapper.data("tie-kamicha");
        var tiePrefix = $wrapper.data("tie-prefix");
        var floatBased = $wrapper.data("float-based");
        var chipUnit = $wrapper.data("chip-unit");

        let tie_option_label = "";
        if (data.scoring_mode === 'float_based') {
          tie_option_label = tieSplit;
        } else if (data.tie_option === 1) {
          tie_option_label = tieKamicha;
        } else if (data.tie_option === 2) {
          tie_option_label = tieSplit;
        } else {
          tie_option_label = "-";
        }

        let umas = "";
        if (data.scoring_mode === 'float_based') {
          umas = floatBased;
        } else if (data.play_type === 3) {
          umas = [data.uma_one, data.uma_two, data.uma_three].join(",");
        } else if (data.play_type === 4) {
          umas = [
            data.uma_one,
            data.uma_two,
            data.uma_three,
            data.uma_four,
          ].join(",");
        }

        $(".js-rule-badge-mochi-kaeshi").text(data.mochi + " / " + data.kaeshi);
        $(".js-rule-badge-uma").text(umas);
        $(".js-rule-badge-pt-calc").text(pt_calc);
        $(".js-rule-badge-chip").toggle(data.is_chip).text(data.is_chip ? data.chip_rate + chipUnit : "");
        $(".js-rule-badge-tie").text(tiePrefix + tie_option_label);
        var $scoreValueSpan = $("<span>", {
          class: "js-remaining_score_value ps-1",
        }).text(all_score);

        var $scoreHiddenSpan = $("<span>", {
          class: "js-remaining_score_hidden_value",
          style: "display:none",
        }).text(all_score);

        $(".js-remaining_score").append($scoreValueSpan, $scoreHiddenSpan);
        updateRemainingScore(); // ajaxが完了したら残得点の計算
      })
      .fail(function (jqXHR) {
        //通信に失敗した際の処理
        clearRuleUI();
      });
  }

  // ● 対局日・家・得点・ptがすべて入力済みかつ家重複状態に応じてボタン状態更新
  function checkFormCompletion() {
    let isComplete = true;

    // match_on, IE, Score, Pointフィールドのチェックと家重複チェック
    $('[id$="_match_on"], [id$="_ie"], [id$="_score"], [id$="_point"]').each(
      function () {
        let value = $(this).val();
        if (
          value === "" ||
          value === null ||
          value === undefined ||
          checkDuplicateIE()
        ) {
          isComplete = false;
          return false; // ループを中断
        }
      },
    );

    // 登録ボタンの状態を更新
    if (isComplete) {
      $("#match_create_btn").prop("disabled", false).removeClass("inactive");
    } else {
      $("#match_create_btn").prop("disabled", true).addClass("inactive");
    }

    // 家の重複は保存できないため、ボタンを止めて警告する
    window.Janreco.toggleFormWarning("#match_create_warning", "seat-duplicate", checkDuplicateIE(), "error");
  }

  // ● 家記録の有効フラグを読み取る（HAML側で data-record-ie が渡される。未指定時は家記録あり扱い）
  function isRecordIe() {
    return $("#match_form").data("recordIe") !== false;
  }

  // ● 得点・pt起点の計算で使う家配列を組み立てる
  //   家記録なし（[id$="_ie"]が存在しない）対局は、得点入力欄のフォーム表示順で 1..n を仮の家として使う（決定18）
  function buildIes() {
    let ies = [];
    let $ieInputs = $('[id$="_ie"]');
    if ($ieInputs.length) {
      $ieInputs.each(function () {
        ies.push(parseInt($(this).val(), 10));
      });
    } else {
      let scoreCount = $('[id$="_score"]').length;
      for (let i = 0; i < scoreCount; i++) {
        ies.push(i + 1);
      }
    }
    return ies;
  }

  // ● 家の重複チェック
  function checkDuplicateIE() {
    let ies = [];
    $('[id$="_ie"]').each(function () {
      ies.push($(this).val());
    });
    let isDuplicate = ies.some(function (ie, index) {
      return ies.indexOf(ie) !== index;
    });
    return isDuplicate;
  }

  // ● 得点項目の入力が残り１つの場合、点数を自動補完する
  function autoCompleteScore() {
    let emptyScoreElements = $('[id$="_score"]').filter(function () {
      return !$(this).val();
    });
    if (emptyScoreElements.length === 1) {
      let remainingScoreText = $(".js-remaining_score_value").text().trim();
      let remainingScore = parseInt(remainingScoreText, 10);
      emptyScoreElements.val(remainingScore / 100);
      updateRemainingScore(); // 残得点更新
      calculate_point_rank(); // ポイント・順位の計算
    }
  }

  // ● pt記録ボタンonでpt項目の入力が残り１つの場合、ptを自動補完する
  function autoCompletePoint() {
    let element = document.getElementById("pt-toggle");
    let checked = element.checked; // チェックボックスの状態を取得(on or off)
    // チェックボックスがonの場合
    if (checked) {
      var points_sum = 0;
      let emptyPointElements = $('[id$="_point"]').filter(function () {
        let value = $(this).val();
        let point = parseFloat(value);
        if (isNaN(point)) {
          point = 0; // デフォルト値
        }
        points_sum += point;
        return !value;
      });
      if (emptyPointElements.length === 1) {
        emptyPointElements.val((points_sum * -1).toFixed(1)); // 残りptを自動補完
        updateRemainingScore(); // 残得点更新
        calculate_score_rank(); // ptから得点と順位を計算
      }
    }
  }

  // ● 得点からポイント・順位の計算する
  function calculate_point_rank() {
    let is_full = true;
    $('[id$="_score"], #match_rule_id').each(function (index) {
      if ($('[id$="_score"], #match_rule_id').eq(index).val() === "") {
        is_full = false; //scoreが空白の場合falseをセット
      }
    });
    // 全プレイヤーのscoreが入力された場合
    if (is_full) {
      let scores_rules_ies = [];
      let rule_id = [];
      let scores = [];
      $('[id$="_score"]').each(function () {
        let score = parseInt($(this).val());
        scores.push(score);
      });
      let ies = buildIes();
      rule_id.push(parseInt($("#match_rule_id").val()));
      // ルール未選択・得点が数値でない場合は送信しない（サーバー側で422になるため）
      if (isNaN(rule_id[0]) || scores.some(isNaN)) {
        return;
      }
      scores_rules_ies.push(rule_id);
      scores_rules_ies.push(scores);
      scores_rules_ies.push(ies);
      // ローディング開始 & リクエスト識別子を更新（最新のみがUIを操作できる）
      const requestToken = ++currentPtCalcRequestToken;
      startPtLoading();
      if (currentPtCalcRequest) {
        currentPtCalcRequest.abort();
      }
      currentPtCalcRequest = $.ajax({
        type: "GET", // リクエストのタイプ
        url: "/matches/calculates", // リクエストを送信するURL
        data: { scores_rules_ies: scores_rules_ies, pt_checked: "off", record_ie: isRecordIe() }, // サーバーに送信するデータ
        dataType: "json", // サーバーから返却される型
      })
        // 正常にデータを受け取れた際の処理
        .done(function (data) {
          // 最新のリクエストでなければ結果を反映しない（レースコンディション回避）
          if (requestToken !== currentPtCalcRequestToken) {
            return;
          }
          $('[id$="_point"]').each(function (i) {
            $(this).val(Math.round(data[0][0][i] * 10) / 10);
          });
          $('[id$="_rank"]').each(function (i) {
            $(this).val(data[0][1][i]);
          });
          checkFormCompletion(); // ボタン状態更新
          updateRemainingScore(); // 残得点更新
        })
        .fail(function (err) {
          //通信に失敗した際の処理（簡易ログ）
        })
        .always(function () {
          // 最新のリクエストのみローディング解除（abortや旧リクエストでは解除しない）
          if (requestToken === currentPtCalcRequestToken) {
            stopPtLoading();
            currentPtCalcRequest = null;
          }
        });
    }
  }

  // ● ptから得点と順位を計算する
  function calculate_score_rank() {
    let element = document.getElementById("pt-toggle");
    let checked = element.checked; // チェックボックスの状態を取得(on or off)
    var inputs = document.querySelectorAll('[id$="_score"]');
    // チェックボックスがonの場合
    if (checked) {
      // "ptで記録"テキスト強調する
      $(".toggle-text").addClass("fw-bold");
      // 得点を入力不可にする
      for (var i = 0; i < inputs.length; i++) {
        $(inputs[i]).readonly = checked;
        $(inputs[i]).removeClass("bg-white");
        $(inputs[i]).addClass("bg-disabled");
        $(inputs[i]).css("pointer-events", "none");
        $(inputs[i]).attr("tabindex", "-1");
      }
      // 得点・順位を計算
      let is_full = true;
      $('[id$="_point"], #match_rule_id').each(function (index) {
        if ($('[id$="_point"], #match_rule_id').eq(index).val() === "") {
          is_full = false; //scoreが空白の場合falseをセット
        }
      });
      // 全プレイヤーのptが入力された場合
      if (is_full) {
        let points_rules_ies = [];
        let rule_id = [];
        let points = [];
        $('[id$="_point"]').each(function () {
          let point = parseFloat($(this).val());
          points.push(point);
        });
        let ies = buildIes();
        rule_id.push(parseInt($("#match_rule_id").val()));
        // ルール未選択・ptが数値でない場合は送信しない（サーバー側で422になるため）
        if (isNaN(rule_id[0]) || points.some(isNaN)) {
          return;
        }
        points_rules_ies.push(rule_id);
        points_rules_ies.push(points);
        points_rules_ies.push(ies);
        $.ajax({
          type: "GET", // リクエストのタイプ
          url: "/matches/calculates", // リクエストを送信するURL
          data: { points_rules_ies: points_rules_ies, pt_checked: "on", record_ie: isRecordIe() }, // サーバーに送信するデータ
          dataType: "json", // サーバーから返却される型
        })
          // 正常にデータを受け取れた際の処理
          .done(function (data) {
            $('[id$="_score"]').each(function (k) {
              $(this).val(Math.round(data[0][k] * 10) / 1000);
            });
            $('[id$="_rank"]').each(function (k) {
              $(this).val(data[1][k]);
            });
            checkFormCompletion(); // ボタン状態更新
            updateRemainingScore(); // 残得点更新
          })
          .fail(function () {
            //通信に失敗した際の処理
          });
      }
    }
    // チェックボックスがoffの場合
    else {
      // "ptで記録"テキスト強調解除する
      $(".toggle-text").removeClass("fw-bold");
      // 得点を入力可にする
      for (var i = 0; i < inputs.length; i++) {
        $(inputs[i]).readonly = checked;
        $(inputs[i]).removeClass("bg-disabled");
        $(inputs[i]).addClass("bg-white");
        $(inputs[i]).css("pointer-events", "auto");
        $(inputs[i]).attr("tabindex", "0");
      }
    }
  }

  // ● <leagueフォーム>ルール選択肢を更新する関数
  function updateRuleList(playType) {
    const requestToken = ++currentLeagueRuleListRequestToken;
    $.ajax({
      url: "/rules/searches/1",
      method: "GET",
      dataType: "json",
      data: { play_type: playType },
      success: function (rules) {
        // 古いレスポンスでUIが巻き戻らないようにする
        if (requestToken !== currentLeagueRuleListRequestToken) return;

        // options差し替え前の「現在の選択」を退避（クリック→選択変更の競合対策）
        const selectedIdBeforeApply = $("#league_rule_id").val();

        var options = rules.map(function (rule) {
          return '<option value="' + rule.id + '">' + rule.name + "</option>";
        });
        $("#league_rule_id").html(options.join(""));

        // 可能なら選択値を復元（差し替えで先頭に戻るのを防ぐ）
        if (
          selectedIdBeforeApply &&
          $('#league_rule_id option[value="' + selectedIdBeforeApply + '"]').length
        ) {
          $("#league_rule_id").val(selectedIdBeforeApply);
        }

        // 詳細表示を選択値と同期
        // ルールが存在しないplay_type（0件）でも、古い詳細が残らないように常に同期する
        selectRule("#league_rule_id");
      },
    });
  }

  // ● <leagueフォーム>選択されているルールのチップ有無によって「リーグ成績にチップptを含めるか」項目を表示・非表示にする
  function updateIsTipValid(is_tip) {
    if (is_tip) {
      $("#is_tip_valid").show();
      // 表示時は選択できるように戻す
      $("#league_is_tip_valid_false").prop("disabled", false);
      $("#league_is_tip_valid_true").prop("disabled", false);
    } else {
      // 非チップルールの場合:
      // - 以前に「含める(true)」が選択されていたとしても矛盾しないよう false を強制
      // - disabled な input は送信されないため、false 側は必ず送信される状態にする
      $("#league_is_tip_valid_false").prop("checked", true).prop("disabled", false);
      $("#league_is_tip_valid_true").prop("checked", false).prop("disabled", true);
      $("#is_tip_valid").hide();
    }
  }

  // *********************************************************************
  // leaguesが含まれていないmatchesのパスに一致するページのとき、ルール検索実行
  if (/^(?!.*leagues).*(\/matches(\/|$))/.test(window.location.pathname)) {
    let selector = "#match_rule_id";
    if (document.querySelector(selector)) {
      selectRule(selector);
    }
    $(selector).on("change", function () {
      selectRule(selector);
    });
    $("#match_create_btn").on("click", function (e) {
      var remainingScore = $(".js-remaining_score_value").text();
      if (parseInt(remainingScore) !== 0) {
        var confirmRegisterMsg = $("#match_form").data("confirm-register-not-zero");
        if (!window.confirm(confirmRegisterMsg)) {
          return false;
        }
      }
    });
  }
  // league作成・編集ページのとき実行
  if (
    /^\/leagues\/new$/.test(window.Janreco.currentPath()) ||
    /^\/leagues\/[^/]+\/edit$/.test(window.Janreco.currentPath())
  ) {
    // ページ読み込み時にルールリストとルール登録リンクを更新
    var initialPlayType = $('input[name="league[play_type]"]:checked').val() || "4";
    // 選択されたルールに対応する詳細を表示
    let selector = "#league_rule_id";

    // ルール選択が可能なページでは、初期ロードでplay_typeに応じてルール一覧を一度だけ整形する
    // （クリック時の非同期更新で選択値が巻き戻る問題を防ぐ）
    if ($(selector).length && !$(selector).is(":disabled")) {
      updateRuleList(initialPlayType);
    } else if ($(selector).val()) {
      // 変更不可（disabled）の場合でも詳細は同期させる
      selectRule(selector);
    }

    // ルールセレクトボックスの値が変更されたときにルール詳細を更新
    $("body").on("change", selector, function () {
      selectRule(selector);
    });
    // play_type ラジオボタンの値が変更されたときにルールリストとルール登録リンクを更新
    $('input[name="league[play_type]"]').on("change", function () {
      var selectedPlayType = $(this).val();
      updateRuleList(selectedPlayType); // ルールリストの更新
    });

  }

  // 得点・pt入力欄のidサフィックス（[id$="_score"]等）は対局フォーム外の要素（例: /meの
  // 家記録スイッチ#user_record_ieやstat_card_max_score）にも偶然マッチしうるため、
  // #match_formが存在するページに限定してバインドする
  if ($("#match_form").length) {
    // ページロード時に関数実行
    checkFormCompletion();
    updateRemainingScore();
    // フィールドの変更時にチェック関数を実行
    $('[id$="_match_on"], [id$="_ie"], [id$="_score"], [id$="_point"]').on(
      "change",
      checkFormCompletion,
    );
    // 得点に変化があったとき、残得点の更新
    $('[id$="_score"]').on("input", updateRemainingScore);
    // 得点の未入力が残り１つの場合、点数を自動補完する
    $('[id$="_score"]').on("blur", autoCompleteScore);
    // 得点・ルール・家に変化があったとき、ポイント・順位を計算して表示
    $('[id$="_score"], #match_rule_id, [id$="_ie"]').on(
      "input",
      calculate_point_rank,
    );
    // ----- ● pt記録ボタンon ------
    // ptに変化があったとき、ポイントから得点・順位を計算して表示
    $('[id$="_point"]').on("input", calculate_score_rank);
    // pt入力チェックボックスがonになったとき、ポイントから得点・順位を計算して表示
    $("#pt-toggle").on("change", calculate_score_rank);
    // ptの未入力が残り１つの場合、点数を自動補完する
    $('[id$="_point"]').on("blur", autoCompletePoint);

    // リセットボタンのイベントハンドラー
    $("#reset-all").on("click", function () {
      if (confirm($("#match_form").data("confirm-reset-score-pt"))) {
        $('[id$="_score"]').val("");
        $('[id$="_point"]').val("");
        updateRemainingScore();
        checkFormCompletion();
      }
    });

    // ptで記録するボタンのイベントハンドラー
    $("#pt-record-btn").on("click", function () {
      const checkbox = $("#pt-toggle");
      const isChecked = checkbox.prop("checked");

      // チェックボックスの状態を切り替え
      checkbox.prop("checked", !isChecked);

      // ボタンの見た目を更新
      if (!isChecked) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }

      // チェックボックスのchangeイベントを発火
      checkbox.trigger("change");
    });
  }
});

// ルール詳細の表示・非表示
$(document).on("click", ".js-rule-dropdown", function () {
  var isCurrentlyVisible = $(".js-rule-details").is(":visible");
  $(".js-rule-details").slideToggle(200);

  var icon = $(this).find("i");
  var label = $(this).find("span.ps-1");
  var dropdownLabelOpen = $(this).data("label-open");
  var dropdownLabelClose = $(this).data("label-close");
  if (isCurrentlyVisible) {
    icon.removeClass("fa-caret-down").addClass("fa-caret-right");
    label.text(dropdownLabelOpen);
  } else {
    icon.removeClass("fa-caret-right").addClass("fa-caret-down");
    label.text(dropdownLabelClose);
  }
});
